<template>
  <div class="resGray lighten-6">
    <void-checks
      v-if="!viewCheck"
      @setDate="setDate"
      :previousProperty="selectedProperty"
      :previousDate="selectedDate"
      @setProperty="setProperty"
      @openCheckDetails="getInfo">
    </void-checks>
    <distribute-details
      v-if="viewCheck"
      @returnVoid="returnVoid"
      @refreshInfo="getInfo"
      :currentCheck="currentCheck"
      :depositDetails="depositDetails">
    </distribute-details>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import VoidChecks from './VoidNsfComponents/VoidChecks'
import DistributeDetails from './VoidNsfComponents/DistributeDetails'
import moment from 'moment'

export default {
  components: {
    VoidChecks,
    DistributeDetails
  },
  data () {
    return {
      depositDetails: {},
      currentCheck: '',
      viewCheck: false,
      selectedProperty: {},
      selectedDate: moment().startOf('month')
    }
  },
  methods: {
    ...mapActions(['initializeStoreItem', 'fetchData']),
    getInfo (val) {
      this.fetchData({ newPage: 'BankDepositSlipDraftsFullInfo', params: { CompanyId: val.companyId, BankAccountCode: val.bankAccountCode, BankDepositSlipId: val.depositSlipId } }).then(() => {
        this.depositDetails = this.currentData('BankDepositSlipDraftsFullInfo')
        if (this.viewCheck === true) {
          this.fetchData({ newPage: 'LeasePayments', params: { Lease: val.payer, BankDepositId: val.depositId } }).then(() => {
            this.viewCheck = true
            this.currentCheck = val.depositId
          })
        } else {
          this.viewCheck = true
          this.currentCheck = val.depositId
        }
      }).catch(error => { console.log(error.response) })
    },
    setDate (val) {
      this.selectedDate = val
    },
    setProperty (val) {
      if (val.value !== null) {
        this.selectedProperty = val
      }
    },
    returnVoid () {
      this.fetchData({newPage: 'BankDepositDetailsVoid', params: { Property: this.selectedProperty.value, AsOfDate: this.selectedDate }}).then(() => {
        this.viewCheck = false
      }).catch(error => { console.log(error.response) })
    }
  },
  computed: {
    ...mapGetters(['currentData'])
  }
}
</script>

<style lang="scss" scoped>
</style>
